/** @jsxImportSource theme-ui */
import { Container, Flex, Heading } from 'theme-ui';
import SubscriptionAuditFilters from '@/containers/voss/SubscriptionAuditFilters';
import SubscriptionAudit from '@/containers/voss/SubscriptionAudit';

const VossSubscriptionAuditPage = () => {
    return (
        <Container>
            <Flex sx={{ flexDirection: 'column', gap: 2 }}>
                <Heading>Subscription audit</Heading>
                <SubscriptionAuditFilters />
                <SubscriptionAudit />
            </Flex>
        </Container>
    );
};

export default VossSubscriptionAuditPage;
